module.exports = __webpack_public_path__ + "static/media/step_2.01917e53.png";